import { gql } from "@apollo/client"

export const UPLOAD_IMAGE = gql`
  mutation UploadImage($UploadImageInput: UploadImageInput!) {
    UploadImage(input: $UploadImageInput) {
      status {
        success
        name
        detail
      }
      Person {
        urlAvatar
        Store {
          urlLogo
        }
      }
      Tournament {
        urlImage
        isPresential
      }
      TournamentType {
        urlImage
      }
      Game {
        urlImage
      }
    }
  }
`
